









































import { ApiCreditcard } from '@/models/api/creditcard'
import ActionToPlan from '@spa/components/pages/mypage/paid-membership/plans/ActionToPlanTemporally.vue'
import NextPayment from '@spa/components/pages/mypage/paid-membership/plans/components/payment-status/for-active-plan/NextPayment.vue'
import NotifyPlanHolding from '@spa/components/pages/mypage/paid-membership/plans/components/payment-status/for-holding-plan/NotifyPlanHolding.vue'
import { PlanGroupViewModel } from '@spa/components/pages/mypage/paid-membership/plans/models/plan-group'
import { Option } from 'fp-ts/lib/Option'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ActionToPlan,
  },
})
export default class PlanGroupHeader extends Vue {
  @Prop({ required: true })
  group: PlanGroupViewModel

  @Prop({ required: true })
  creditcard: Option<ApiCreditcard>

  /**
   * 2022/08時点で「現在のプラン」がなければ次回支払いは存在しない。
   * 一方で、「現在のプラン」があるのに次回支払いが存在しない場合はある。
   * ex. 解約して月末に無効になるケース
   * ex. 保留中のケース
   *
   * @see https://github.com/my-color/front/issues/6885 保留中のケースについて
   */
  get showHeader(): boolean {
    return this.group.currentPlan !== undefined
  }

  get paymentStatus() {
    const currentPlan = this.group.currentPlan! // ヘッダーを表示するなら現在プランは確実に存在する

    if (currentPlan.holding()) {
      return NotifyPlanHolding
    }

    return NextPayment
  }

  get notices(): string[] {
    if (!this.group.nextPayment) {
      return []
    }

    return this.group.nextPayment.notice
  }
}
